module.exports = __webpack_public_path__ + "img/sedapar-logo.4e866f5a.png";